export default __webpack_public_path__ + "static/media/center_icon.caff76f0.jpg";